type BookmarkColBodyText = {
  btnToolTipText: string;
  btnAriaLabel: string;
  btnClassName: string;
};

export interface BookmarkColBodyProps {
  text: BookmarkColBodyText;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const BookmarkColumnBody = ({ text, onClick }: BookmarkColBodyProps): JSX.Element => {
  return (
    <div
      id="bookmarkBtnWrapper"
      className="columnBtnWrapper"
    >
      <button
        type="button"
        onClick={onClick}
        className={`${text.btnClassName} hasTooltip`}
        aria-label={text.btnAriaLabel}
        tabIndex={0}
        data-pr-tooltip={text.btnToolTipText}
        data-pr-position="top"
        data-pr-showdelay={1000}
      >
        <span className="bookmarkResourceIcon">
          <i className="fa-regular fa-bookmark" />
        </span>
      </button>
    </div>
  );
};
